import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export function HeaderCourseModal() {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="h5">{t('add_course') || 'Course'}</Typography>
    </Box>
  )
}
